export const categories = [
  { id: 'hot', name: '热门推荐', slug: 'hot', icon: 'ri-fire-line', count: 128 },
  { id: 'latest', name: '最新上映', slug: 'latest', icon: 'ri-film-line', count: 56 },
  { id: 'domestic', name: '国产精品', slug: 'domestic', icon: 'ri-china-railway-line', count: 342 },
  { id: 'asia', name: '亚洲专区', slug: 'asia', icon: 'ri-earth-line', count: 215 },
  { id: 'western', name: '欧美大片', slug: 'western', icon: 'ri-global-line', count: 189 },
  { id: 'anime', name: '动漫卡通', slug: 'anime', icon: 'ri-emotion-line', count: 167 },
  { id: 'variety', name: '综艺娱乐', slug: 'variety', icon: 'ri-live-line', count: 94 },
  { id: 'documentary', name: '纪录片', slug: 'documentary', icon: 'ri-camera-lens-line', count: 73 },
];

export const videos = [
  {
    id: 'v001',
    title: '春日晚风 · 都市情感大片',
    slug: 'spring-breeze-urban-romance',
    thumbnail: 'https://readdy.ai/api/search-image?query=Romantic%20urban%20evening%20scene%20with%20two%20figures%20silhouetted%20against%20city%20skyline%20at%20sunset%2C%20soft%20warm%20golden%20hour%20lighting%2C%20cinematic%20composition%2C%20film%20grain%20texture%2C%20dreamy%20atmosphere%2C%20professional%20movie%20poster%20style%2C%20elegant%20and%20sophisticated&width=640&height=360&seq=video-thumb-001&orientation=landscape',
    duration: '48:32',
    category: 'hot',
    categoryName: '热门推荐',
    views: 1289000,
    date: '2026-08-09',
    description: '都市中的两个人，在春日黄昏的街头擦肩而过。一段关于错过与重逢的现代爱情故事，由知名导演倾力打造，画面极富诗意。全片采用4K超清画质拍摄，每一个镜头都如同一幅精心构图的画作。',
    tags: ['爱情', '都市', '剧情', '文艺'],
    rating: 9.2,
    featured: true,
  },
  {
    id: 'v002',
    title: '星际迷途 · 科幻冒险巨制',
    slug: 'star-lost-sci-fi-adventure',
    thumbnail: 'https://readdy.ai/api/search-image?query=Futuristic%20spaceship%20interior%20with%20astronaut%20looking%20at%20distant%20galaxy%20through%20large%20window%2C%20deep%20space%20nebula%20colors%2C%20cinematic%20sci-fi%20aesthetic%2C%20dramatic%20lighting%2C%20professional%20movie%20poster%20design%2C%20epic%20scale&width=640&height=360&seq=video-thumb-002&orientation=landscape',
    duration: '1:56:18',
    category: 'western',
    categoryName: '欧美大片',
    views: 2156000,
    date: '2026-08-05',
    description: '在遥远的未来，人类已经遍布银河系。一支探险队在执行任务时发现了古老的外星文明遗迹，由此揭开了一场关于人类起源的惊人秘密。好莱坞顶级特效团队打造，视觉震撼前所未有。',
    tags: ['科幻', '冒险', '太空', '特效'],
    rating: 8.9,
    featured: true,
  },
  {
    id: 'v003',
    title: '江南旧事 · 民国风情画卷',
    slug: 'jiangnan-old-stories',
    thumbnail: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20water%20town%20scenery%20with%20stone%20bridges%20and%20willow%20trees%20in%20misty%20morning%20light%2C%20nostalgic%20vintage%20atmosphere%2C%20elegant%20period%20drama%20aesthetic%2C%20soft%20warm%20tones%2C%20cinematic%20composition&width=640&height=360&seq=video-thumb-003&orientation=landscape',
    duration: '52:10',
    category: 'domestic',
    categoryName: '国产精品',
    views: 987000,
    date: '2026-08-08',
    description: '民国初年的江南水乡，一个家族三代人的命运沉浮。从大家闺秀到时代新女性，她们在时代的洪流中寻找属于自己的道路。精良的制作、细腻的表演，展现了那个年代独有的韵味。',
    tags: ['民国', '家族', '历史', '女性'],
    rating: 9.5,
    featured: false,
  },
  {
    id: 'v004',
    title: '东京爱情故事 · 跨国恋曲',
    slug: 'tokyo-love-story-2026',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cherry%20blossom%20season%20in%20Tokyo%20street%20with%20couple%20walking%20under%20pink%20petals%2C%20warm%20spring%20lighting%2C%20romantic%20atmosphere%2C%20Japanese%20urban%20backdrop%2C%20cinematic%20film%20look%2C%20soft%20focus&width=640&height=360&seq=video-thumb-004&orientation=landscape',
    duration: '1:12:45',
    category: 'asia',
    categoryName: '亚洲专区',
    views: 1563000,
    date: '2026-08-03',
    description: '一位中国女孩在东京的留学之旅，邂逅了一段跨越国界的真挚感情。从涩谷的霓虹到京都的古寺，从陌生到熟悉，她在异国他乡找到了真正属于自己的幸福。',
    tags: ['爱情', '跨国', '日本', '青春'],
    rating: 8.7,
    featured: true,
  },
  {
    id: 'v005',
    title: '龙之传说 · 东方奇幻史诗',
    slug: 'dragon-legend-fantasy',
    thumbnail: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20dragon%20soaring%20above%20misty%20mountains%20with%20traditional%20temple%20in%20foreground%2C%20golden%20clouds%2C%20epic%20fantasy%20art%20style%2C%20cinematic%20lighting%2C%20mystical%20atmosphere&width=640&height=360&seq=video-thumb-005&orientation=landscape',
    duration: '2:05:30',
    category: 'anime',
    categoryName: '动漫卡通',
    views: 3124000,
    date: '2026-07-28',
    description: '改编自同名畅销小说的东方奇幻史诗动画电影。讲述了少年龙骑士在古老神龙的指引下，踏上拯救世界的冒险之旅。融合中国传统神话元素与现代动画技术，画面精美绝伦。',
    tags: ['奇幻', '动画', '冒险', '神话'],
    rating: 9.3,
    featured: true,
  },
  {
    id: 'v006',
    title: '笑声传奇 · 喜剧之王争霸赛',
    slug: 'laugh-legend-competition',
    thumbnail: 'https://readdy.ai/api/search-image?query=Bright%20colorful%20comedy%20stage%20with%20spotlights%20and%20confetti%2C%20energetic%20live%20show%20atmosphere%2C%20warm%20vibrant%20lighting%2C%20entertainment%20show%20aesthetic%2C%20professional%20TV%20studio%20production&width=640&height=360&seq=video-thumb-006&orientation=landscape',
    duration: '1:30:00',
    category: 'variety',
    categoryName: '综艺娱乐',
    views: 489000,
    date: '2026-08-07',
    description: '全国顶尖喜剧人齐聚一堂，展开一场笑料百出的巅峰对决。从相声到小品，从脱口秀到即兴喜剧，各种形式的幽默碰撞出最灿烂的火花。每期都有神秘嘉宾惊喜助阵。',
    tags: ['喜剧', '综艺', '竞技', '搞笑'],
    rating: 8.5,
    featured: false,
  },
  {
    id: 'v007',
    title: '深海秘境 · 自然探索之旅',
    slug: 'deep-sea-mystery',
    thumbnail: 'https://readdy.ai/api/search-image?query=Deep%20ocean%20with%20bioluminescent%20creatures%20and%20coral%20reef%2C%20sunlight%20rays%20penetrating%20water%20surface%2C%20mysterious%20underwater%20world%2C%20professional%20nature%20documentary%20style%2C%20crystal%20clear%20blue%20water&width=640&height=360&seq=video-thumb-007&orientation=landscape',
    duration: '1:05:22',
    category: 'documentary',
    categoryName: '纪录片',
    views: 723000,
    date: '2026-08-01',
    description: '跟随科考团队潜入地球上最神秘的深海世界。从马里亚纳海沟到百慕大三角，从珊瑚大三角到南极冰盖下的隐秘生态，揭示深海中未曾被人类发现的奇观。',
    tags: ['自然', '海洋', '探索', '科学'],
    rating: 9.4,
    featured: false,
  },
  {
    id: 'v008',
    title: '武林风云 · 江湖恩怨录',
    slug: 'martial-world-chronicles',
    thumbnail: 'https://readdy.ai/api/search-image?query=Martial%20arts%20master%20standing%20on%20bamboo%20forest%20at%20sunset%20with%20flowing%20robes%2C%20traditional%20Chinese%20wuxia%20aesthetic%2C%20golden%20dust%20particles%20in%20air%2C%20cinematic%20composition%2C%20epic%20scale&width=640&height=360&seq=video-thumb-008&orientation=landscape',
    duration: '1:48:15',
    category: 'domestic',
    categoryName: '国产精品',
    views: 2789000,
    date: '2026-07-30',
    description: '北宋末年，朝廷腐败，江湖纷争四起。一代宗师在乱世中崛起，以一己之力平衡各方势力。刀光剑影之间，既有快意恩仇的豪情，也有儿女情长的柔情。国产武侠巅峰之作。',
    tags: ['武侠', '古装', '动作', '江湖'],
    rating: 9.1,
    featured: true,
  },
  {
    id: 'v009',
    title: '巴黎之恋 · 法式浪漫喜剧',
    slug: 'paris-romance-comedy',
    thumbnail: 'https://readdy.ai/api/search-image?query=Eiffel%20Tower%20at%20sunset%20with%20couple%20on%20cobblestone%20street%2C%20warm%20romantic%20Parisian%20atmosphere%2C%20cafe%20terraces%2C%20golden%20hour%20lighting%2C%20French%20film%20aesthetic%2C%20charming%20and%20elegant&width=640&height=360&seq=video-thumb-009&orientation=landscape',
    duration: '1:34:28',
    category: 'western',
    categoryName: '欧美大片',
    views: 1345000,
    date: '2026-08-02',
    description: '一个笨拙的美国厨师在巴黎追寻米其林之梦，却意外收获了爱情。在塞纳河畔、在蒙马特高地、在卢森堡公园，每一个转角都藏着惊喜。法式幽默与浪漫的完美结合。',
    tags: ['喜剧', '爱情', '法国', '美食'],
    rating: 8.6,
    featured: false,
  },
  {
    id: 'v010',
    title: '青春不散场 · 校园热血番',
    slug: 'youth-never-ends',
    thumbnail: 'https://readdy.ai/api/search-image?query=Japanese%20high%20school%20rooftop%20at%20sunset%20with%20group%20of%20friends%2C%20anime%20art%20style%20inspired%20scene%2C%20warm%20nostalgic%20colors%2C%20cherry%20blossom%20petals%2C%20youthful%20energy%2C%20cinematic%20composition&width=640&height=360&seq=video-thumb-010&orientation=landscape',
    duration: '45:30',
    category: 'anime',
    categoryName: '动漫卡通',
    views: 1923000,
    date: '2026-08-06',
    description: '五个性格迥异的高中生，在高三最后一年组成了篮球梦之队。从最初的互不信任到最终的默契配合，他们在赛场上挥洒汗水，在青春里留下了最闪亮的回忆。热血与感动交织的校园物语。',
    tags: ['青春', '校园', '运动', '友情'],
    rating: 9.0,
    featured: false,
  },
  {
    id: 'v011',
    title: '荒野求生 · 极限挑战记',
    slug: 'wild-survival-challenge',
    thumbnail: 'https://readdy.ai/api/search-image?query=Dramatic%20wilderness%20landscape%20with%20mountains%20and%20forest%20at%20golden%20hour%2C%20adventure%20survival%20theme%2C%20rugged%20natural%20beauty%2C%20cinematic%20documentary%20style%2C%20warm%20earthy%20tones&width=640&height=360&seq=video-thumb-011&orientation=landscape',
    duration: '55:18',
    category: 'variety',
    categoryName: '综艺娱乐',
    views: 876000,
    date: '2026-08-04',
    description: '八位明星被投放到无人荒岛，只有最基本的生存工具。在三十天的极限挑战中，他们必须学会生火、捕鱼、搭建庇护所。人性的真实一面在绝境中展露无遗。',
    tags: ['冒险', '真人秀', '自然', '挑战'],
    rating: 8.4,
    featured: false,
  },
  {
    id: 'v012',
    title: '舌尖上的故乡 · 美食人文纪录',
    slug: 'taste-of-hometown',
    thumbnail: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20kitchen%20with%20steaming%20food%20and%20warm%20lighting%2C%20rustic%20wooden%20table%20with%20various%20dishes%2C%20nostalgic%20home%20cooking%20atmosphere%2C%20soft%20natural%20light%2C%20food%20documentary%20style&width=640&height=360&seq=video-thumb-012&orientation=landscape',
    duration: '1:20:45',
    category: 'documentary',
    categoryName: '纪录片',
    views: 1567000,
    date: '2026-07-25',
    description: '走遍中国三十个省份，探寻最地道的地方美食。每一道菜背后都有一个动人的故事，每一种味道都承载着故乡的记忆。这不仅是一部美食纪录片，更是一部中国人的情感地图。',
    tags: ['美食', '人文', '旅行', '乡土'],
    rating: 9.6,
    featured: true,
  },
];

export const features = [
  {
    id: 'f001',
    title: '4K超清画质体验',
    description: '全系列视频支持4K超高清画质，带给你影院级的观影享受。',
    icon: 'ri-4k-line',
  },
  {
    id: 'f002',
    title: '多线路流畅播放',
    description: '智能CDN加速，多条播放线路自动切换，告别卡顿等待。',
    icon: 'ri-speed-up-line',
  },
  {
    id: 'f003',
    title: '海量正版内容',
    description: '涵盖电影、剧集、综艺、动漫等全品类内容，每日更新不断档。',
    icon: 'ri-stack-line',
  },
  {
    id: 'f004',
    title: '多端无缝切换',
    description: '支持手机、平板、电脑多端同步观看，随时随地继续精彩。',
    icon: 'ri-device-line',
  },
];

export const faqs = [
  {
    question: '蜜桃传媒需要下载App才能观看吗？',
    answer: '不需要。蜜桃传媒支持在线网页播放，无需下载任何软件或App，打开浏览器即可畅享全部内容。同时我们也提供移动端App，您可以根据需要选择使用。',
  },
  {
    question: '蜜桃传媒的视频画质如何？',
    answer: '蜜桃传媒所有视频均支持高清（720P）、全高清（1080P）和超高清（4K）多种画质选择，系统会根据您的网络状况自动匹配最佳画质，您也可以手动切换。',
  },
  {
    question: '蜜桃传媒的内容多久更新一次？',
    answer: '我们每天都会更新最新内容。热门剧集、综艺节目会在播出后2小时内上线，电影内容也会第一时间跟进。关注首页"最新更新"板块不错过任何精彩。',
  },
  {
    question: '蜜桃传媒是否收费？',
    answer: '蜜桃传媒目前提供大量免费内容供用户观看。部分独家内容可能需要会员权益，我们会始终在内容详情页明确标注，确保用户知情选择。',
  },
  {
    question: '在国外可以观看蜜桃传媒吗？',
    answer: '可以。蜜桃传媒面向全球用户提供服务，无论您身在何处，只要有网络连接，就可以访问蜜桃传媒观看精彩内容。我们部署了全球CDN加速节点，确保海外用户同样能获得流畅的观看体验。',
  },
];

export const testimonials = [
  {
    id: 't001',
    name: '张先生',
    role: '资深影迷',
    content: '蜜桃传媒的画质真的太棒了！4K超清看大片完全就是影院级的体验，而且更新速度很快，新片上映没几天就能看到。',
    rating: 5,
  },
  {
    id: 't002',
    name: '李女士',
    role: '全职妈妈',
    content: '每天带娃累了就打开蜜桃传媒看看综艺放松一下。内容丰富，操作简单，连我这种不擅长用电子产品的人都能轻松上手。',
    rating: 5,
  },
  {
    id: 't003',
    name: '王同学',
    role: '大学生',
    content: '宿舍里和室友一起用蜜桃传媒追剧已经成了日常。多线路播放很稳定，再也不怕看到关键剧情突然卡住了，强烈推荐！',
    rating: 5,
  },
];

export const specialTopics = [
  {
    id: 's001',
    title: '暑期档 · 清凉一夏',
    description: '精选最适合夏天观看的影片合集',
    image: 'https://readdy.ai/api/search-image?query=Summer%20beach%20scene%20with%20palm%20trees%20and%20clear%20blue%20ocean%2C%20refreshing%20tropical%20vibe%2C%20bright%20sunlight%2C%20vacation%20mood%2C%20cinematic%20wide%20shot%2C%20cool%20and%20breezy%20atmosphere&width=800&height=450&seq=special-topic-001&orientation=landscape',
    count: 36,
  },
  {
    id: 's002',
    title: '国风经典 · 千年传承',
    description: '中国传统文化的影视盛宴',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20ink%20painting%20style%20landscape%20with%20mountains%20and%20mist%2C%20elegant%20calligraphy%20elements%2C%20ancient%20Chinese%20aesthetic%2C%20artistic%20composition%2C%20warm%20sepia%20tones%2C%20cultural%20heritage&width=800&height=450&seq=special-topic-002&orientation=landscape',
    count: 52,
  },
  {
    id: 's003',
    title: '悬疑剧场 · 烧脑推理',
    description: '高能反转让你大呼过瘾',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20dimly%20lit%20room%20with%20detective%20board%20and%20red%20strings%2C%20film%20noir%20aesthetic%2C%20dramatic%20shadows%2C%20suspense%20atmosphere%2C%20cinematic%20lighting%2C%20warm%20amber%20and%20deep%20brown%20tones&width=800&height=450&seq=special-topic-003&orientation=landscape',
    count: 28,
  },
];

export const brandInfo = {
  name: '蜜桃传媒',
  slogan: '精彩视界，触手可及',
  founded: '2018',
  description: '蜜桃传媒成立于2018年，是一家专注于高品质视频内容制作与分发的综合性传媒平台。我们致力于为用户提供最优质的视听体验，涵盖电影、电视剧、综艺、动漫、纪录片等全品类内容。以技术创新为驱动，以内容品质为核心，蜜桃传媒已经成长为国内领先的在线视频平台之一。',
  mission: '让每一个精彩故事都能被世界看到',
  vision: '成为全球用户首选的在线视频娱乐平台',
  values: ['内容为王', '用户至上', '技术创新', '诚信共赢'],
  stats: [
    { label: '累计用户', value: '5000万+' },
    { label: '视频总量', value: '10万+' },
    { label: '日播放量', value: '3000万+' },
    { label: '合作品牌', value: '2000+' },
  ],
  contact: {
    email: 'contact@mitaomedia.com',
    phone: '400-888-9999',
    address: '北京市朝阳区传媒文化产业园A座18层',
    wechat: '蜜桃传媒官方',
    weibo: '@蜜桃传媒官微',
  },
};